<template>
  <div id="app">
    <header>
      <img :src="topImg" class="bg_image" alt="" />
      <img :src="logoutImg" class="logout" v-show="unLogin" @click="logout" alt="" />
    </header>
    <div id="banner_content">
      <router-view />
    </div>
    <footer>
      <ul>
        <li class="tips">{{ textDict.tips }}</li>
        <li class="agreement">
          <span class="user" @click="goUserAgreement">{{ textDict.userAgreement }}</span>
          <span class="privacy" @click="goPrivacyAgreement">{{ textDict.privacyAgreement }}</span>
        </li>
        <li class="desc">
          <div>{{ textDict.company }}</div>
          <div>{{ textDict.email }}</div>
        </li>
      </ul>
    </footer>
  </div>
</template>
<script>
import dict from "@/dict/index"
export default {
  data() {
    return {
      topImg: require("@/assets/top.png"),
      descImg: require("@/assets/bottomDesc.png"),
      userImg: require("@/assets/userImg.png"),
      privacyImg: require("@/assets/privacyImg.png"),
      logoutImg: require("@/assets/logout.png"),
      userAgreement: {
        HK: "http://www.amazingcat.ltd/userprotocol.html",
        KR: "http://rgkr.sqsfywl.com/userprotocol_kr.html"
      },
      privacyAgreement: {
        HK: "http://www.amazingcat.ltd/private.html",
        KR: "http://rgkr.sqsfywl.com/private_kr.html"
      },
      mobileUrl: {
        HK: "https://rcg.mcjdhjj.com/abroad/mobile/dist/#/login",
        KR: "https://rechargekr.shhws.cn/abroad/mobile/dist/#/login"
      },
      textDict: dict.app
    };
  },
  mounted() {
    var u = navigator.userAgent;
    if (!!u.match(/AppleWebKit.*Mobile.*/) && process.env.NODE_ENV === 'production') {
      location.href = this.mobileUrl[this.$store.state.language]
    }
  },
  computed: {
    unLogin() {
      return !["/findPassword", "/login"].includes(this.$route.path);
    },
  },
  methods: {
    goUserAgreement() {
      window.open(this.userAgreement[this.$store.state.language]); // 
    },
    goPrivacyAgreement() {
      window.open(this.privacyAgreement[this.$store.state.language]);
    },
    logout() {
      this.$confirm(`${this.textDict.methods.logoutMsg}?`, this.textDict.methods.tips, {
        confirmButtonText: this.textDict.methods.confirm,
        cancelButtonText: this.textDict.methods.cancellation,
        type: 'warning'
      }).then(() => {
        localStorage.removeItem("pay_pc_token");
        localStorage.removeItem("pay_pc_uid");
        this.$router.push(`/login?lang=${this.$store.state.language}`);
      }).catch(() => {
      })
    },
  },
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
  font-family: Microsoft YaHei,微软雅黑;
}

li {
  list-style: none;
}
</style>
<style lang="less" scoped>
header {
  height: 90px;
  width: 100%;
  background-color: #fff;
  position: relative;

  .bg_image {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 75px;
  }

  .logout {
    position: absolute;
    height: 40px;
    width: 40px;
    z-index: 10;
    right: 50px;
    top: 25px;
    cursor: pointer;
  }
}

#banner_content {
  width: 100%;
  height: calc(100vh - 210px);
  background-color: #f4f5f4;
}

footer {
  width: 100vw;
  height: 120px;
  overflow: hidden;
  // background-image: url("./assets/bottomBgi.png");

  ul {
    height: 100%;
    margin: auto;
    color: #313131;
    font-weight: 500;
    .tips {
      font-size: 12px;
      text-align: center;
      height: 30px;
      line-height: 30px;
    }
    .agreement {
      font-size: 12px;
      text-align: center;
      height: 30px;
      line-height: 30px;

      span {
        display: inline-block;
        width: 100px;
      }
    }

    .desc {
      font-size: 12px;
      text-align: center;

      div {
        height: 25px;
        line-height: 25px;
      }
    }
  }
}
</style>
